module.exports = __webpack_public_path__ + "static/media/neutral.60c13cb8.png";